import { useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "../../../components/ui/table";
import { EditFyersUserModal } from "./EditFyersUserModal";
import { EditNubraUserModal } from "./EditNubraUserModal";
import { EditDhanXTSUserModal } from "./EditDhanXTSUserModal";
import { EditDhanHQUserModal } from "./EditDhanHQUserModal";
import apiClient from "../../../utils/apiClient";
import formatToIndianCurrency from "../../../utils/formatCurrency";
import { ChevronsUpDownIcon } from "lucide-react";

export default function FyersUsersListTable({
  fyersUsersData,
  fetchFyersUserList,
}) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getSortedData = () => {
    if (!fyersUsersData || !sortConfig.key) {
      return fyersUsersData?.sort(
        (a, b) => (b.status === "active") - (a.status === "active")
      );
    }

    const sortedData = [...fyersUsersData].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Handle balance sorting (convert to number)
      if (sortConfig.key === "balance") {
        aValue = parseFloat(aValue) || 0;
        bValue = parseFloat(bValue) || 0;
      }

      // Handle string sorting (case insensitive)
      if (typeof aValue === "string" && typeof bValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    return sortedData;
  };

  const sortedData = getSortedData();

  return (
    // <div className="mt-4 relative overflow-auto custom-scroll max-h-[calc(100vh-150px)] ">
    //   <Table className="relative h-full">
    //     <TableHeader className="bg-muted sticky top-0 h-[4px] z-10">
    //       <TableRow className="">
    //         <TableHead className="h-8 text-left text-[12px]">S.No</TableHead>
    //         <TableHead
    //           className="h-8 text-left text-[12px] cursor-pointer select-none"
    //           onClick={() => handleSort("client_id")}
    //         >
    //           <div className="flex items-center">
    //             Client Id{" "}
    //             <span className="inline-block ml-1 text-white">
    //               <ChevronsUpDownIcon className="h-3 w-3 text-white" />
    //             </span>
    //           </div>
    //         </TableHead>
    //         <TableHead
    //           className="h-8 text-left text-[12px] cursor-pointer select-none"
    //           onClick={() => handleSort("client_id")}
    //         >
    //           <div className="flex items-center">
    //             Broker{" "}
    //             <span className="inline-block ml-1 text-white">
    //               <ChevronsUpDownIcon className="h-3 w-3 text-white" />
    //             </span>
    //           </div>
    //         </TableHead>
    //         <TableHead
    //           className="h-8 text-left text-[12px] cursor-pointer select-none"
    //           onClick={() => handleSort("name")}
    //         >
    //           <div className="flex items-center">
    //             Name{" "}
    //             <span className="inline-block ml-1 text-white">
    //               <ChevronsUpDownIcon className="h-3 w-3 text-white" />
    //             </span>
    //           </div>
    //         </TableHead>
    //         <TableHead
    //           className="h-8 text-left text-[12px] cursor-pointer select-none"
    //           onClick={() => handleSort("status")}
    //         >
    //           <div className="flex items-center">
    //             Status{" "}
    //             <span className="inline-block ml-1 text-white">
    //               <ChevronsUpDownIcon className="h-3 w-3 text-white" />
    //             </span>
    //           </div>
    //         </TableHead>
    //         <TableHead
    //           className="h-8 text-left text-[12px] cursor-pointer select-none"
    //           onClick={() => handleSort("balance")}
    //         >
    //           <div className="flex items-center">
    //             Available Balance
    //             <span className="inline-block ml-1 text-white">
    //               <ChevronsUpDownIcon className="h-3 w-3 text-white" />
    //             </span>
    //           </div>
    //         </TableHead>
    //         <TableHead className="h-8 text-center text-[12px]">
    //           Actions
    //         </TableHead>
    //       </TableRow>
    //     </TableHeader>
    //     <TableBody>
    //       {sortedData?.map((item, idx) => (
    //         <TableRow key={item.client_id}>
    //           <TableCell className="text-left py-1 text-white px-3">
    //             {idx + 1}
    //           </TableCell>
    //           <TableCell className="text-left py-1 text-white px-3">
    //             {item.client_id}
    //           </TableCell>
    //           <TableCell className="text-left py-1 text-white px-3">
    //             {item.broker}
    //           </TableCell>
    //           <TableCell className="text-left py-1 text-white px-3">
    //             {item.name}
    //           </TableCell>
    //           <TableCell className="text-left py-1 text-white px-3">
    //             {item.status === "active" ? (
    //               <span className="inline-block w-2 h-2 mr-2 rounded-full bg-green-500"></span>
    //             ) : (
    //               <span className="inline-block w-2 h-2 mr-2 rounded-full bg-rose-500"></span>
    //             )}
    //             {item.status}
    //           </TableCell>
    //           <TableCell className="text-left py-1 text-[#07F2C7] px-3">
    //             {formatToIndianCurrency(item.balance)}
    //           </TableCell>
    //           <TableCell className="text-center py-1 text-white px-3">
    //             {item.broker === "nubra" ? (
    //               <EditNubraUserModal
    //                 userDetails={item}
    //                 fetchFyersUserList={fetchFyersUserList}
    //               />
    //             ) : item.broker === "dhan_ss" ? (
    //               <EditFyersUserModal
    //                 userDetails={item}
    //                 fetchFyersUserList={fetchFyersUserList}
    //               />
    //             ) : item.broker === "dhan_anurag" ? (
    //               <EditFyersUserModal
    //                 userDetails={item}
    //                 fetchFyersUserList={fetchFyersUserList}
    //               />
    //             ) : (
    //               <EditFyersUserModal
    //                 userDetails={item}
    //                 fetchFyersUserList={fetchFyersUserList}
    //               />
    //             )}
    //           </TableCell>
    //         </TableRow>
    //       ))}
    //     </TableBody>
    //   </Table>
    // </div>

    <div className="mt-4 relative overflow-auto custom-scroll max-h-[calc(100vh-150px)]">
      <table className="relative h-full w-full">
        <thead className="bg-muted sticky top-0 z-10">
          <tr>
            <th className="h-8 text-left text-[12px] bg-muted px-4 text-white/80">S.No</th>
            <th
              className="h-8 text-left text-[12px] cursor-pointer select-none bg-muted px-4 text-white/80"
              onClick={() => handleSort("client_id")}
            >
              <div className="flex items-center">
                Client Id{" "}
                <span className="inline-block ml-1 text-white">
                  <ChevronsUpDownIcon className="h-3 w-3 text-white" />
                </span>
              </div>
            </th>
            <th
              className="h-8 text-left text-[12px] cursor-pointer select-none bg-muted px-4 text-white/80"
              onClick={() => handleSort("client_id")}
            >
              <div className="flex items-center">
                Broker{" "}
                <span className="inline-block ml-1 text-white">
                  <ChevronsUpDownIcon className="h-3 w-3 text-white" />
                </span>
              </div>
            </th>
            <th
              className="h-8 text-left text-[12px] cursor-pointer select-none bg-muted px-4 text-white/80"
              onClick={() => handleSort("name")}
            >
              <div className="flex items-center">
                Name{" "}
                <span className="inline-block ml-1 text-white">
                  <ChevronsUpDownIcon className="h-3 w-3 text-white" />
                </span>
              </div>
            </th>
            <th
              className="h-8 text-left text-[12px] cursor-pointer select-none bg-muted px-4 text-white/80"
              onClick={() => handleSort("status")}
            >
              <div className="flex items-center">
                Status{" "}
                <span className="inline-block ml-1 text-white">
                  <ChevronsUpDownIcon className="h-3 w-3 text-white" />
                </span>
              </div>
            </th>
            <th
              className="h-8 text-left text-[12px] cursor-pointer select-none bg-muted px-4 text-white/80"
              onClick={() => handleSort("balance")}
            >
              <div className="flex items-center">
                Available Balance
                <span className="inline-block ml-1 text-white">
                  <ChevronsUpDownIcon className="h-3 w-3 text-white" />
                </span>
              </div>
            </th>
            <th className="h-8 text-center text-[12px] bg-muted px-4 text-white/80">
              Proxy
            </th>
            <th className="h-8 text-center text-[12px] bg-muted px-4 text-white/80">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData?.map((item, idx) => (
            <tr key={`${item.client_id}_${item.broker}`} className="border-b border-border">
              <td className="text-left py-1 text-white font-medium text-[14px] px-3">
                {idx + 1}
              </td>
              <td className="text-left py-1 text-white font-medium text-[14px] px-3">
                {item.client_id}
              </td>
              <td className="text-left py-1 text-white font-medium text-[14px] px-3">
                {item.broker === 'dhan_hq' ? 'DHQ' : item.broker}
              </td>
              <td className="text-left py-1 text-white font-medium text-[14px] px-3">
                {item.name}
              </td>
              <td className="text-left py-1 text-white font-medium text-[14px] px-3">
                {item.status === "active" ? (
                  <span className="inline-block w-2 h-2 mr-2 rounded-full bg-green-500"></span>
                ) : (
                  <span className="inline-block w-2 h-2 mr-2 rounded-full bg-rose-500"></span>
                )}
                {item.status}
              </td>
              <td className="text-left py-1 text-[#07F2C7] px-3">
                {formatToIndianCurrency(item.balance)}
              </td>
              <td className="text-center py-1 text-white font-medium text-[14px] px-3">
                {item.proxy_toggle ? (
                  <span className="text-green-500 text-xs font-semibold px-2 py-1 bg-green-500/10 rounded-full">
                    Active
                  </span>
                ) : (
                  <span className="text-gray-400 text-xs font-semibold px-2 py-1 bg-gray-500/10 rounded-full">
                    Disabled
                  </span>
                )}
              </td>
              <td className="text-center py-1 text-white font-medium text-[14px] px-3">
                {item.broker === "nubra" ? (
                  <EditNubraUserModal
                    userDetails={item}
                    fetchFyersUserList={fetchFyersUserList}
                  />
                ) : item.broker === "dhan_xts" || item.broker === "dhan_xts_anurag" ? (
                  <EditDhanXTSUserModal
                    userDetails={item}
                    fetchFyersUserList={fetchFyersUserList}
                  />
                ) : item.broker === "dhan_hq" ? (
                  <EditDhanHQUserModal
                    userDetails={item}
                    fetchFyersUserList={fetchFyersUserList}
                  />
                ) : item.broker === "dhan_ss" || item.broker === "dhan_anurag" || item.broker === "fyers" ? (
                  <EditFyersUserModal
                    userDetails={item}
                    fetchFyersUserList={fetchFyersUserList}
                  />
                ) : (
                  <EditFyersUserModal
                    userDetails={item}
                    fetchFyersUserList={fetchFyersUserList}
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
